import { css } from "@agapi/ui/panda/css";

export const stepMarkerStyles = css({
  // maskImage: 'token(assets.shape2)',
  maskSize: 'contain',
  maskRepeat: 'none',
  backgroundColor: 'surface.primary.vibrant.background',
  minWidth: 'items.xl',
  height: 'items.xl',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'surface.primary.vibrant.foreground'
})